import dayjs from 'dayjs'
import {Apprentice} from '../model/person.model'

/**
 * not started = < 0
 * sem1 = < 6
 * sem2 = 12
 * sem3 = 18
 * sem4 = 24
 * sem5 = 30
 * sem6 = 36
 * sem7 = 42
 * sem8 = 48
 * @param {Date} apprenticeStartDate
 * @param apprenticeshipDurationInYears
 * @returns {number | undefined}
 */
export const getActiveSemester = (apprenticeStartDate: Date, apprenticeshipDurationInYears: number): number => {
	const monthsPassedSinceStart = dayjs().diff(apprenticeStartDate, 'month')
	const apprenticeshipDurationInMonths = apprenticeshipDurationInYears * 12
	const daysPassedSinceStart = dayjs().diff(apprenticeStartDate, 'day')


	if (monthsPassedSinceStart === 0 && daysPassedSinceStart >= 0 ) {
		return 1
	}
	if(monthsPassedSinceStart <= 0) {
		// apprenticeship has not yet started
		return 0
	}
	if (monthsPassedSinceStart > apprenticeshipDurationInMonths) {
		// person is out of apprenticeships
		return -1
	}

	const yearsPassed = Math.floor(monthsPassedSinceStart / 12)

	if (yearsPassed < 1) {
		if (monthsPassedSinceStart <= 6) {
			return 1
		}
		return 2
	}
	if (yearsPassed === 1) {
		if ((monthsPassedSinceStart - 12) <= 6) {
			return 3
		}
		return 4
	}

	if (yearsPassed === 2) {
		if ((monthsPassedSinceStart - 24) <= 6) {
			return 5
		}
		return 6
	}
	if (yearsPassed === 3) {
		if ((monthsPassedSinceStart - 36) <= 6) {
			return 7
		}
		return 8
	}
	return -1
}

// queries active semester
// returns -1 if undefined or the apprentices is out of apprenticeship
// returns 0 if the apprenticeship has not yet started
export const getActiveSemesterOfApprentice = (apprentice: Apprentice | undefined): number => {
	if (!apprentice) {
		return -1
	}

	const apprenticeStart = apprentice?.apprentice?.contract_start
	const apprenticeEnd = apprentice?.apprentice?.contract_end
	let act_semester = 0
	if (apprenticeStart && apprenticeEnd) {
		const apprenticeStartDate = new Date(apprenticeStart)
		const apprenticeEndDate = new Date(apprenticeEnd)
		const today = new Date()
		const totalApprenticeshipDurationInYears =
			apprenticeEndDate.getFullYear() - apprenticeStartDate.getFullYear()
		act_semester = getActiveSemester(apprenticeStartDate, totalApprenticeshipDurationInYears)
		if (today < apprenticeStartDate) {
			act_semester = 1
		}
		if (today > apprenticeEndDate) {
			act_semester = totalApprenticeshipDurationInYears * 2
		}
	} else {
		act_semester = 0
	}

	return act_semester
}